<template>
  <base-create-form
    :create-form="createForm"
    :formTitle="formTitle"
    @submitForm="submitForm"
    @cancel="cancel"
  ></base-create-form>
</template>

<script>
import { BaseCreateForm } from "@/components/Base/index.js";
import sanitizer from "sanitizer";
import { CriterionService } from "../../../services/criterion.service";
import { CriterionCategoriesService } from "../../../services/criterionCategories.service";
export default {
  name: "CriterionCreateForm",
  components: { BaseCreateForm },
  data() {
    return {
      formTitle: this.$t("page_title.criterion_create"),
      createForm: [
        {
          label: this.$t("criterion.name"),
          name: "name",
          value: "",
          type: "input",
          required: true,
          validateRule: "required"
        },
        {
          label: this.$t("criterion.category_name"),
          name: "criterion_category_id",
          value: "",
          type: "select",
          options: [],
          required: true,
          validateRule: "required"
        },
        {
          label: this.$t("criterion.description"),
          name: "description",
          value: "",
          type: "textarea",
          required: false,
          validateRule: ""
        }
      ]
    };
  },
  methods: {
    cancel() {
      this.$router.push({ name: "CriterionList" });
    },
    async submitForm(params) {
      const response = await new CriterionService().create(params);
      if (!response) return;
      this.$notify({
        title: this.$t("common.created"),
        text: this.$t("common.created_text", {
          name: this.$t("criterion.title"),
          value: sanitizer.escape(response.name)
        }),
        type: "success"
      });
      setTimeout(() => this.$router.push({ name: "CriterionList" }), 500);
    },
    async getCriterionCategories() {
      const response = await new CriterionCategoriesService().getList({
        limit: 1000
      });
      this.createForm[1].options = response.data || [];
      return response.data;
    }
  },
  created() {
    this.getCriterionCategories();
  }
};
</script>

<style scoped></style>
